import { render } from "./ShowPanchangaInfo.vue?vue&type=template&id=5d52445c&scoped=true"
import script from "./ShowPanchangaInfo.vue?vue&type=script&lang=js"
export * from "./ShowPanchangaInfo.vue?vue&type=script&lang=js"

import "./ShowPanchangaInfo.vue?vue&type=style&index=0&id=5d52445c&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2784445594/src/vedicastrochart-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d52445c"]])

export default __exports__